// see https://stackoverflow.com/a/856569
export default 2147483647;
